/**
 * 1.8.3 (D-1.8.3-6) — the requests of the standby list.
 *
 *   the month page's "Yes, add me"      POST /api/link/volunteer-month { t, eventId, a: 'yes', standby: true }
 *   an outing's standby answer          POST /api/link/vol/outing-standby { t, answer: 'yes' | 'no' }
 *   an outing's Offer to the next       POST /api/volunteers/outings/<eventId>/offer-standby
 *
 * (The event page's own Offer press is the 1.7.4 `{ what: 'offerNext', offer: { role: 'volunteer' } }`, and the
 * event link's answer rides in `answer.standby` — neither needs a request of its own.)
 */
import type { VolunteerMonthAction } from '@shared/event-calendar';
import type { OutingView } from '@shared/volunteers-api';
import { apiFetch } from '@/lib/api';

const post = <T,>(path: string, body: unknown) => apiFetch<T>(path, { method: 'POST', body: JSON.stringify(body) });

export const answerMonthStandbyReq = (token: string, eventId: string) => post<VolunteerMonthAction>('/api/link/volunteer-month', { t: token, eventId, a: 'yes', standby: true });

export interface OutingOfferResult {
  offered: string;
  emailed: boolean;
  message: string;
  outing: OutingView;
}
export const offerOutingStandbyReq = (eventId: string) => post<OutingOfferResult>(`/api/volunteers/outings/${encodeURIComponent(eventId)}/offer-standby`, {});

/** D-1103-VB-2: the office marks a volunteer who called or wrote that they cannot come to the group outing; the place opens again. */
export const outingVolunteerWithdrawReq = (eventId: string, volunteerId: string) => post<{ ok: boolean; result: string; message: string }>(`/api/volunteers/outings/${encodeURIComponent(eventId)}/volunteers/${encodeURIComponent(volunteerId)}/withdraw`, {});
